export default __webpack_public_path__ + "static/cookies-fbe41aaf3d6a09c1267a6f372aecb00f.png";